import { html, ref, slotted, when } from "@microsoft/fast-element";
const dismissSVG = html `
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.58859 4.21569L4.64645 4.14645C4.82001 3.97288 5.08944 3.9536 5.28431 4.08859L5.35355 4.14645L10.5 9.293L15.6464 4.14645C15.82 3.97288 16.0894 3.9536 16.2843 4.08859L16.3536 4.14645C16.5271 4.32001 16.5464 4.58944 16.4114 4.78431L16.3536 4.85355L11.207 10L16.3536 15.1464C16.5271 15.32 16.5464 15.5894 16.4114 15.7843L16.3536 15.8536C16.18 16.0271 15.9106 16.0464 15.7157 15.9114L15.6464 15.8536L10.5 10.707L5.35355 15.8536C5.17999 16.0271 4.91056 16.0464 4.71569 15.9114L4.64645 15.8536C4.47288 15.68 4.4536 15.4106 4.58859 15.2157L4.64645 15.1464L9.793 10L4.64645 4.85355C4.47288 4.67999 4.4536 4.41056 4.58859 4.21569L4.64645 4.14645L4.58859 4.21569Z"
      fill="currentColor"
    />
  </svg>
`;
/**
 * The template for the {@link @fabric-msft/fabric-web#(Tag:class)} component.
 * @public
 */
export function tagTemplate() {
    return html `
    <template>
      <div
        class="container"
        part="container"
        aria-disabled=${(x) => x.disabled}
      >
        <slot name="image" class="image" part="image"></slot>
        <div class="content" part="content">
          <slot name="leadingIcon" ${slotted("leadingIconSlotted")}></slot>
          <div class="textContent" part="textContent">
            <slot
              name="text"
              class="textPrimary ${(x) => x.textSizePrimary}"
              ${slotted("textPrimarySlotted")}
            ></slot>
            <slot
              name="textSecondary"
              class="textSecondary caption2"
              ${slotted("textSecondarySlotted")}
            ></slot>
            <slot></slot>
          </div>

          ${when((x) => x.dismissButton, html `
              <fluent-button
                class="dismissButton"
                part="dismissButton"
                ${ref("dismissButtonRef")}
                appearance="subtle"
                ?disabled=${(x) => x.disabled}
                aria-label="${(x) => x.textPrimaryContent}"
              >
                <slot name="dismissIcon">${dismissSVG}</slot>
              </fluent-button>
            `)}
        </div>
      </div>
    </template>
  `;
}
export const template = tagTemplate();
//# sourceMappingURL=tag.template.js.map